import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import { get } from 'lodash';

const baseString = 'vra-zone-soil-item-full';
const classString = classNames({
  [`${baseString}`]: true
});
const ZoneSoilItemShort = ({
  soil
}) => (
  <section className={classString}>
    <span>{get(soil, 'parsed-muname') || getMessage('text__other')}</span>
  </section>
);
ZoneSoilItemShort.propTypes = {
  soil: PropTypes.object.isRequired
};
export default ZoneSoilItemShort;
